import React from 'react';
import type {
	WidgetDataSourceProps,
	EditWidgetRowProps
} from 'App/components/hooks/integrations/externalIntegrationTypes';
import { Flex, Input, Text } from '@upsales/components';
import WidgetFieldSetting from './helpers/WidgetFieldSetting';
import useTagTranslator from './useTagTranslator';
import moment from 'moment';
import './UiWidgetDate.scss';

export const EditUiWidgetDate = ({ row, onUpdate }: EditWidgetRowProps) => {
	const text = row.settings?.text || '';
	const dateFormat = row.settings?.dateFormat || 'YYYY-MM-DD';

	const handleChange = (key: string, value: string) => {
		onUpdate({
			...row,
			settings: {
				...row.settings,
				[key]: value
			}
		});
	};

	return (
		<Flex direction="column" gap="u2">
			<WidgetFieldSetting text="Text">
				<Input value={text} onChange={e => handleChange('text', e.target.value)} />
			</WidgetFieldSetting>
			<WidgetFieldSetting text="Date format">
				<Input value={dateFormat} onChange={e => handleChange('dateFormat', e.target.value)} />
			</WidgetFieldSetting>
		</Flex>
	);
};

const UiWidgetDate: React.FC<WidgetDataSourceProps> = ({ row, dataSources, widgetSettings }) => {
	const translatedText = useTagTranslator(row.settings, dataSources, widgetSettings);
	const dateFormat = row.settings?.dateFormat || 'YYYY-MM-DD';

	let formattedDate = '';
	if (translatedText) {
		const date = moment(translatedText);
		formattedDate = date.isValid() ? date.format(dateFormat) : translatedText;
	}

	return <Text className="UiWidgetDate__text">{formattedDate}</Text>;
};

export default UiWidgetDate;
